import { ENV_CLIENT_ID } from '@/configs/environment';
import lineLogo from '@/assets/images/pngs/LINE-logo.png';
import { t } from 'i18next';
import { STATE_AUTH_PARAMS } from '@/configs/constants';

interface LineButtonProps {
    state: string
}

const LineButton: React.FC<LineButtonProps> = ({ state }) => {
    const clientId = ENV_CLIENT_ID.lineClientId;
    const redirectUri = ENV_CLIENT_ID.redirectUrl;
    const handleLogin = () => {
        const url = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&state=${state}&scope=openid%20email%20profile&nonce=RANDOM_NONCE`;
        window.location.href = `${url}`;
    };

    return (
        <div onClick={handleLogin} className='w-full h-[48px] rounded-full border-borderGray border-[1px] flex justify-center items-center cursor-pointer content-center'>
            <img src={lineLogo} alt='lineLogo' className='w-[24px] h-[24px]' />
            <p className='ml-[10px] text-[15px] text-text font-semibold'>{t('text.viaLine')}</p>
        </div>
    );
};

export default LineButton;
